<template>
    <div class=" w-full">
        <div class=" px-4 hidden md:flex items-center">
            <div  class=" mr-4">
                <a class="m-0 p-0 items-center flex cursor-pointer flex-wrap" @click="onHomeClick">
                    <feather-icon icon="HomeIcon" svgClasses="h-6 w-6" class="ml-1 mb-1 text-primary2" />
                </a>
            </div>

            <div class=" mr-3" ref="productDropdownContainer">
                <MultiLevelMenu
                    :isMenuOpen="isProductActive"
                    title="Products"
                    :items="navigationSettings.product"
                    @itemClick="redirectToCategory"
                    @menuClick="handleProductMenuClick"
                />
            </div>


            <div class=" mr-3" ref="brandDropdownContainer">
                <BrandDropdown
                    ref="dropdownContainer"
                    title="Brands"
                    :brandData="navigationSettings.brands"
                    @itemClick="redirectToBrand"
                    :isMenuOpen="isBrandActive"
                    @menuClick="handleBrandMenuClick"
                />
            </div>

            <div
                class=" text-primary2 font-medium menuTitle py-1 px-2 rounded-lg cursor-pointer text-lg"
                @click="redirectToPromotions"
            >
                Promotions
            </div>
            <div
                class=" text-primary2 font-medium menuTitle py-1 px-2 rounded-lg cursor-pointer text-lg"
                @click="redirectToFreshLifePromotions"
                v-if="freshLifedata.isActive"
            >
                Fresh Summit
            </div>
            <template v-if="$isAuRegion()">
                <div
                    class=" text-primary2 font-medium menuTitle py-1 px-2 rounded-lg cursor-pointer text-lg"
                    @click="redirectToFreshTraining"
                >
                    Fresh Training
                </div>
                <div
                    class=" text-primary2 font-medium menuTitle py-1 px-2 rounded-lg cursor-pointer text-lg"
                    @click="redirectToFreshHealth"
                >
                    Fresh Health
                </div>
            </template>
        </div>

        <!-- Mobile -->
        <nav class="shop-chip-nav md:hidden" aria-label="Main" ref="chipNav">
            <div class="shop-chip-scroll">
                <div class="shop-chip-row">
                    <a
                        v-for="chip in mobileChips"
                        :key="chip.id"
                        class="shop-chip"
                        :href="chip.href"
                        :aria-current="activeChip === chip.id ? 'page' : null"
                        :target="chip.external ? '_blank' : null"
                        :rel="chip.external ? 'noopener noreferrer' : null"
                        @click="onChipClick($event, chip)"
                    ><span>{{ chip.label }}</span></a>
                </div>
            </div>
        </nav>

        <vs-popup class="learnMorePopup" :fullscreen="true"  :active.sync="productPopupActive" :button-close-hidden="true" title="">
            <div>
                <div>
                    <!-- product header -->
                    <div class=" bg-primary2 text-white flex justify-between p-3">
                        <div class=" cursor-pointer mr-5"></div>
                        <div class=" cursor-pointer">Categories</div>
                        <div class=" cursor-pointer" @click="clearPopup">
                            <vs-icon icon="close" size="small" class=" mr-4 cursor-pointer"></vs-icon>
                        </div>
                    </div>

                    <!-- product list -->
                    <div v-if="step === 1">
                        <vs-list>
                            <div
                                v-for="product, index in navigationSettings.product"
                                :key="index"
                                @click="handleParentClick(product, index)"
                            >
                                <vs-list-item
                                    :title="product.name"
                                    class=" text-primary2 cursor-pointer"
                                >
                                    <vs-icon icon="arrow_forward_ios" size="small" class=" mr-4 cursor-pointer"></vs-icon>
                            </vs-list-item>
                        </div>
                        </vs-list>
                    </div>
                    <div v-if="step === 2">
                        <vs-list>
                            <div
                                v-for="items, index in navigationSettings.product[selectedProductIndex].categories"
                                @click="handleSecondLevelClick(items, index)"
                                :key="index"
                                >
                                <vs-list-item
                                    :title="items.name"
                                    class=" text-primary2 cursor-pointer"
                                >
                                    <vs-icon icon="arrow_forward_ios" size="small" class=" mr-4 cursor-pointer" ></vs-icon>
                                </vs-list-item>
                            </div>

                            <div
                                @click="redirectToCategory(navigationSettings.product[selectedProductIndex].slug)"

                                :key="navigationSettings.product[selectedProductIndex].categories.length"
                            >
                                <vs-list-item
                                    class="text-primary2 cursor-pointer"
                                    :title="`SHOP ALL ${navigationSettings.product[selectedProductIndex].name.toUpperCase()}`"
                                >

                                    <vs-icon icon="arrow_forward_ios" size="small" class=" mr-4 cursor-pointer" ></vs-icon>
                                </vs-list-item>
                            </div>
                        </vs-list>
                    </div>
                    <div v-if="step === 3">
                        <vs-list>
                            <div
                                v-for="items, index in navigationSettings.product[selectedProductIndex].categories[selectedSecondProductIndex].categories"
                                @click="redirectToCategory(items.slug)"
                                :key="index"
                            >
                                <vs-list-item
                                    :title="items.name"
                                    class=" text-primary2 cursor-pointer"
                                >
                                    <vs-icon icon="arrow_forward_ios" size="small" class=" mr-4 cursor-pointer" ></vs-icon>
                                </vs-list-item>
                            </div>
                            <div
                                @click="redirectToCategory(navigationSettings.product[selectedProductIndex].categories[selectedSecondProductIndex].slug)"
                                :key="navigationSettings.product[selectedProductIndex].categories[selectedSecondProductIndex].length"
                            >
                                <vs-list-item
                                    class="text-primary2 cursor-pointer"
                                    :title="`SHOP ALL ${navigationSettings.product[selectedProductIndex].categories[selectedSecondProductIndex].name.toUpperCase()}`"
                                >

                                    <vs-icon icon="arrow_forward_ios" size="small" class=" mr-4 cursor-pointer" ></vs-icon>
                                </vs-list-item>
                            </div>
                        </vs-list>
                    </div>
                </div>
            </div>
        </vs-popup>
        <vs-popup class="learnMorePopup brand-sheet" :fullscreen="true"  :active.sync="brandPopupActive" :button-close-hidden="true" title="">
            <div class="brand-sheet__frame">
                <div class="brand-sheet__header bg-primary2 text-white flex justify-between p-3">
                        <div class=" cursor-pointer mr-5"></div>
                        <div class=" cursor-pointer">Brands</div>
                        <div class=" cursor-pointer" @click="brandPopupActive=false">
                            <vs-icon icon="close" size="small" class=" mr-4 cursor-pointer"></vs-icon>
                        </div>
                    </div>

                    <!-- brand list -->
                    <div class="brand-sheet__body p-5">
                        <div class=" my-5 px-3">
                            <span class="text-primary2 font-medium">Popular Brands</span>
                            <div class="grid grid-cols-2 justify-items-center gap-2">
                                <div
                                    v-for="i in navigationSettings.brands.featured_brands"
                                    :key="i"
                                    class="brand-card cursor-pointer hover:bg-primary3 w-full flex items-center justify-center"
                                    @click="redirectToBrand(i.slug)"
                                >
                                    <img
                                        class=" w-24 object-contain"
                                        style="height: 70px"
                                        :src="i.image"
                                        alt="brand_image"
                                        loading="lazy"
                                        decoding="async"
                                        width="96"
                                        height="70"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class=" my-5">
                            <span class="text-primary2 font-medium">Anti Wrinkle Brands</span>
                            <div class=" ">
                                <div
                                  class=" text-primary2 hover:underline font-normal category-items pr-5"
                                  @click="redirectToBrand(item.slug)"
                                  v-for="item, index in navigationSettings.brands.antiwrinkle_brands"
                                  :key="index"
                                >
                                    {{ item.name }}
                                </div>
                            </div>
                        </div>
                        <div class=" my-5">
                            <span class="text-primary2 font-medium">Filler Brands</span>
                            <div class="">
                                <div
                                    class=" text-primary2 hover:underline font-normal category-items pr-5"
                                    @click="redirectToBrand(item.slug)"
                                    v-for="item, index in navigationSettings.brands.filler_brands"
                                    :key="index"
                                >
                                    {{ item.name }}
                                </div>
                            </div>
                        </div>
                        <div class=" my-5">
                            <span class="text-primary2 font-medium">Biostimulator Brands</span>
                            <div class="">
                                <div
                                    class=" text-primary2 hover:underline font-normal category-items pr-5"
                                    @click="redirectToBrand(item.slug)"
                                    v-for="item, index in navigationSettings.brands.biostimulator"
                                    :key="index"
                                >
                                    {{ item.name }}
                                </div>
                            </div>
                        </div>
                        <!-- Fresh Business is intentionally presence-gated (unlike the sibling
                             sections above) so the header only shows once an admin curates the
                             fresh_business key in the navigation JSON — keeps it hidden on regions
                             that don't configure it. See CPC-776. -->
                        <div class=" my-5" v-if="navigationSettings.brands.fresh_business && navigationSettings.brands.fresh_business.length">
                            <span class="text-primary2 font-medium">Fresh Business</span>
                            <div class="">
                                <div
                                    class=" text-primary2 hover:underline font-normal category-items pr-5"
                                    @click="redirectToBrand(item.slug)"
                                    v-for="item, index in navigationSettings.brands.fresh_business"
                                    :key="index"
                                >
                                    {{ item.name }}
                                </div>
                            </div>
                        </div>
                        <div class=" my-5">
                            <span class="text-primary2 font-medium">Brand A - Z</span>
                            <div class="">
                                <div
                                    class=" text-primary2 hover:underline font-normal category-items pr-5"
                                    v-for="item, index in navigationSettings.brands.all_brands"
                                    :key="index"
                                    @click="redirectToBrand(item.slug)"
                                    style="font-size: 14px"
                                >
                                    {{item.name}}
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import MultiLevelMenu from './DropdownItem.vue';
import BrandDropdown from './brandsDropdown.vue';
import { isUndefined  } from 'lodash';


export default {
    components: {
        MultiLevelMenu,
        BrandDropdown,
    },
    data: () => ({
        navigationSettings: {
          product: [],
          brands: {},
        },
        productPopupActive: false,
        brandPopupActive: false,
        step: 1,
        selectedProductIndex: -1,
        selectedSecondProductIndex: -1,
        isProductActive: false,
        isBrandActive: false,
        freshLifedata:{},
        pressedChip: '',
    }),
    computed: {
        mobileChips() {
            const chips = [
                { id: 'products', label: 'Products', href: this.shopPath('/shop'), action: 'products' },
                { id: 'brands', label: 'Brands', href: this.shopPath('/shop'), action: 'brands' },
                { id: 'promotions', label: 'Promotions', href: this.shopPath('/shop/promotions'), action: 'promotions' },
            ];
            if (this.freshLifedata && this.freshLifedata.isActive) {
                chips.push({
                    id: 'summit',
                    label: 'Fresh Summit',
                    href: this.shopPath('/shop/fresh-summit'),
                    action: 'summit',
                });
            }
            if (this.$isAuRegion()) {
                chips.push({
                    id: 'training',
                    label: 'Fresh Training',
                    href: process.env.VUE_APP_FRESH_TRAINING_LINK || '#',
                    external: true,
                });
                chips.push({
                    id: 'health',
                    label: 'Fresh Health',
                    href: process.env.VUE_APP_FRESH_HEALTH_LINK || '#',
                    external: true,
                });
            }
            return chips;
        },
        activeChip() {
            return this.pressedChip || this.chipFromRoute();
        },
    },
    watch: {
        '$route.fullPath': function () {
            this.pressedChip = this.chipFromRoute();
            this.scrollActiveChip(false);
        },
        productPopupActive(open) {
            if (!open) this.pressedChip = this.chipFromRoute();
        },
        brandPopupActive(open) {
            if (!open) this.pressedChip = this.chipFromRoute();
        },
    },
    methods: {
        ...mapActions('eCommerce', ['getJsonSettings']),
        async getNavSettings() {
            try{
                const res = await this.getJsonSettings({ slug: 'navigation' });
                this.navigationSettings = res.data.data;
            }
            catch(err){
                console.log(err);
            }
        },
        async getFreshLifeSettings() {
            try{
                const res = await this.getJsonSettings({ slug: 'fresh-summit' });
                this.freshLifedata = res.data.data;
            }
            catch(err){
                console.log(err);
            }
        },
        shopPath(suffix) {
            const userType = this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.userType;
            if (userType === 'superAdmin') {
                return suffix === '/shop' ? '/super-admin/store/shop' : `/super-admin/store${suffix}`;
            }
            const owner = this.$route.path.split('/')[1];
            return `/${owner}${suffix}`;
        },
        chipFromRoute() {
            const path = this.$route.path;
            if (path.includes('/shop/brands')) return 'brands';
            if (path.includes('/shop/fresh-summit')) return 'summit';
            if (path.includes('/shop/promotions')) return 'promotions';
            if (path.includes('/shop/category') || /\/shop\/?$/.test(path)) return 'products';
            return '';
        },
        onChipClick(event, chip) {
            this.pressedChip = chip.id;
            this.scrollActiveChip(true);
            if (chip.external) return;
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
            event.preventDefault();
            if (chip.action === 'products') this.productPopupActive = true;
            else if (chip.action === 'brands') this.brandPopupActive = true;
            else if (chip.action === 'promotions') this.redirectToPromotions();
            else if (chip.action === 'summit') this.redirectToFreshLifePromotions();
        },
        scrollActiveChip(shouldFocus) {
            this.$nextTick(() => {
                const nav = this.$refs.chipNav;
                if (!nav || !nav.querySelector) return;
                const current = nav.querySelector('[aria-current="page"]');
                const scroller = nav.querySelector('.shop-chip-scroll');
                if (!current || !scroller) return;
                const scrollerRect = scroller.getBoundingClientRect();
                const chipRect = current.getBoundingClientRect();
                const delta = chipRect.left - scrollerRect.left - (scrollerRect.width - chipRect.width) / 2;
                scroller.scrollTo({ left: Math.max(0, scroller.scrollLeft + delta), behavior: 'smooth' });
                if (shouldFocus && current.focus) current.focus({ preventScroll: true });
            });
        },
        onHomeClick() {
            let owner = this.$route.path.split('/')[1];
            const userType = this.$store.state.AppActiveUser.userType;
            if (userType === 'superAdmin') owner = 'super-admin/store';

            this.$router.push(`/${owner}/shop`);
        },
        handleProductMenuClick(){
            if(this.isProductActive){
                this.isProductActive = false;
            }
            else {
                this.isProductActive = true;
            }
        },
        handleBrandMenuClick(){
            if(this.isBrandActive){
                this.isBrandActive = false;
            }
            else {
                this.isBrandActive = true;
            }
        },
        handleParentClick(product, index){
            if(product.categories.length > 0){
                this.step = 2;
                this.selectedProductIndex = index;
            }
            else {
                this.redirectToCategory(product.slug);
            }
        },
        handleSecondLevelClick(product, index) {
            if(product.categories.length > 0){
                this.step = 3;
                this.selectedSecondProductIndex = index;
            }
            else {
                this.redirectToCategory(product.slug);
            }
        },
        redirectToCategory(slug = '') {
            console.log(slug, 'slug');
            this.isProductActive = false;
            if(slug !== '' || !isUndefined(slug) ){
                const userType = JSON.parse(
                    localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`)
                ).userType;
                const role = localStorage.getItem(
                    `${process.env.VUE_APP_ACCESS_TOKEN_NAME}Role`
                );

                let routerName = '';
                if (role === 'Org Owner') {
                    routerName = 'OrgOwnerOrderCenterCategoryPage';
                }
                else {
                    if (userType === 'doctor') {
                        routerName = 'DoctorOrderCenterCategoryPage';
                    }
                    if (userType === 'nurse') {
                        routerName = 'NurseOrderCenterCategoryPage';
                    }
                    if (userType === 'superAdmin') {
                        routerName = 'SuperAdminOrderCenterCategoryPage';
                    }
                    if (userType === 'basic') {
                        routerName = 'BasicOrderCenterCategoryPage';
                    }
                }

                this.$router.push({
                    name: routerName,
                    params: {
                        slug: slug,
                    },
                    query: {
                        page: 1,
                    },
                });

                this.clearPopup();
            }
        },
        redirectToBrand(slug = ''){
            this.isBrandActive = false;
            this.brandPopupActive = false;
            if(slug !== ''){
                const userType = JSON.parse(
                    localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`)
                ).userType;
                const role = localStorage.getItem(
                    `${process.env.VUE_APP_ACCESS_TOKEN_NAME}Role`
                );

                let routerName = '';
                if (role === 'Org Owner') {
                    routerName = 'OrgOwnerOrderCenterBrandPage';
                } else {
                    if (userType === 'doctor') {
                        routerName = 'DoctorOrderCenterBrandPage';
                    } if (userType === 'nurse') {
                        routerName = 'NurseOrderCenterBrandPage';
                    }
                    if (userType === 'superAdmin') {
                        routerName = 'SuperAdminOrderCenterBrandPage';
                    }
                    if (userType === 'basic') {
                        routerName = 'BasicOrderCenterBrandPage';
                    }
                }
                this.$router.push({
                    name: routerName,
                    params: {
                        slug: slug,
                    },
                    query: {
                        page: 1,
                    },
                });
            }
        },
        redirectToFreshLifePromotions(){
            this.isBrandActive = false;
            this.brandPopupActive = false;
                const userType = JSON.parse(
                    localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`)
                ).userType;
                const role = localStorage.getItem(
                    `${process.env.VUE_APP_ACCESS_TOKEN_NAME}Role`
                );

                let routerName = '';
                if (role === 'Org Owner') {
                    routerName = 'OrgOwnerOrderCenterFreshLifePage';
                } else {
                    if (userType === 'doctor') {
                        routerName = 'DoctorOrderCenterFreshLifePage';
                    } if (userType === 'nurse') {
                        routerName = 'NurseOrderCenterFreshLifePage';
                    }
                    if (userType === 'superAdmin') {
                        routerName = 'SuperAdminFreshlifePage';
                    }if (userType === 'basic') {
                        routerName = 'BasicOrderCenterFreshLifePage';
                    }
                }
                this.$router.push({
                    name: routerName});
        },
        redirectToPromotions(){
            this.isBrandActive = false;
            this.brandPopupActive = false;
            const userType = JSON.parse(
                localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`)
            ).userType;
            const role = localStorage.getItem(
                `${process.env.VUE_APP_ACCESS_TOKEN_NAME}Role`
            );

            let routerName = '';
            if (role === 'Org Owner') {
                routerName = 'OrgOwnerOrderCenterPromotionsPage';
            } else {
                if (userType === 'doctor') {
                    routerName = 'DoctorOrderCenterPromotionsPage';
                } if (userType === 'nurse') {
                    routerName = 'NurseOrderCenterPromotionsPage';
                }
                if (userType === 'superAdmin') {
                    routerName = 'SuperAdminPromotionsPage';
                }if (userType === 'basic') {
                    routerName = 'BasicOrderCenterPromotionsPage';
                }
            }
            this.$router.push({name: routerName});
        },
        redirectToFreshTraining() {
            window.open(process.env.VUE_APP_FRESH_TRAINING_LINK, '_blank');
        },
        redirectToFreshHealth() {
            const url = process.env.VUE_APP_FRESH_HEALTH_LINK;
            window.open(url, '_blank');
        },
        clearPopup(){
            this.productPopupActive = false,
            this.step = 1,
            this.selectedProductIndex= -1;
        },
        handleClickOutside(event, dropdownRef) {
            const dropdownContainer = this.$refs[dropdownRef];
            if (dropdownContainer && !dropdownContainer.contains(event.target)) {
                if (dropdownRef === 'productDropdownContainer') {
                    this.isProductActive = false;
                } else if (dropdownRef === 'brandDropdownContainer') {
                    this.isBrandActive = false;
                }
            }
        },
    },
    mounted() {
        this.scrollActiveChip(false);

        // keep the bound references: removeEventListener only matches on identity,
        // so a fresh arrow literal in beforeDestroy would never remove anything
        this.clickHandlers = ['productDropdownContainer', 'brandDropdownContainer'].map(
            (dropdownRef) => (event) => this.handleClickOutside(event, dropdownRef)
        );
        this.clickHandlers.forEach((handler) => document.addEventListener('click', handler));
    },

    beforeDestroy() {
        (this.clickHandlers || []).forEach((handler) => document.removeEventListener('click', handler));
        this.clickHandlers = [];
    },
    created() {
        this.getNavSettings();
        this.getFreshLifeSettings();
    },
};
</script>

<style>

.product-dropdown-position {
    left: 218px !important;
}
.brand-dropdown-position{
    /* left:  183.75px  !important; */
    width: 1000px;
}
.services-dropdown-position{
    left:  343.75px  !important;
}
.promotions-dropdown-position{
    left:  409.75px  !important;
}

@media (min-width: 1200px) {
        .product-dropdown-position {
            left: 481px !important;
        }
        .brand-dropdown-position {
            left: 1291.75px !important;
        }
        .services-dropdown-position {
            left: 606px !important;
        }
        .promotions-dropdown-position {
            left: 668px !important;
        }
}
.brand-card {
  width: 150px;
  height: 150px;
  flex-shrink: 0;
  border: 1px solid #E5E7EB !important;
}

.brand-card:hover img {
  filter: invert(100%);
}

.menu-height{
  min-width: 100%;
  writing-mode: vertical-lr;
  max-height: 80vh;
  @media (min-width: 768px) {
    height: 570px;
  }
  @media (min-width: 900px) {
    height: 550px;
  }
  @media (min-width: 1400px) {
    height: 510px;
  }
}

.category-items {
  min-width: 190px;
  line-height: 2rem;
  margin-right: 20px;
  cursor: pointer;
  writing-mode: horizontal-tb;
}

.con-vs-popup.fullscreen .vs-popup {
    width: 100% !important;
    max-width: 100% !important;
    height: 100% !important;
    max-height: 100% !important;
    margin: 0 !important;
    border-radius: 0 !important;
}
[dir] .vs-popup--title h3 {
    display: none !important;
}

.con-vs-popup.learnMorePopup .vs-popup--content,
[dir] .con-vs-popup .vs-popup--content {
    width: 100% !important;
    padding: 0px !important;
    margin: 0px !important;
}

.con-vs-popup.learnMorePopup .vs-list,
.con-vs-popup.learnMorePopup .vs-list--item {
    width: 100% !important;
}

.con-vs-popup.brand-sheet .vs-popup {
    display: flex;
    flex-direction: column;
    overflow: hidden !important;
}

.con-vs-popup.brand-sheet .vs-popup--content {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    height: auto !important;
    max-height: none !important;
    overflow: hidden !important;
}

.brand-sheet__frame {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-height: 0;
}

.brand-sheet__header {
    flex: 0 0 auto;
}

.brand-sheet__body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
}

.vs-popup--content {
    max-height: 100vh !important;
}

.vs-list--title{
    font-weight: 400 !important;
}

.menuTitle:hover {
  background-color: #F3FAF8;
}

.shop-chip-nav {
  width: 100%;
}

.shop-chip-scroll {
  overflow-x: auto;
  padding: 0 16px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-mask-image: linear-gradient(to right, #000 85%, transparent);
  mask-image: linear-gradient(to right, #000 85%, transparent);
}

.shop-chip-scroll::-webkit-scrollbar {
  display: none;
  height: 0;
}

.shop-chip-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
  width: max-content;
  padding: 2px 0;
}

.shop-chip {
  display: inline-flex;
  align-items: center;
  height: 44px;
  color: #0A1F15;
  font-family: Aeonik, "Helvetica Neue", Arial, sans-serif;
  font-size: 15px;
  line-height: 1;
  text-decoration: none;
  white-space: nowrap;
}

.shop-chip span {
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  height: 40px;
  padding: 0 18px;
  border-radius: 999px;
  border: 1px solid #E0E2DC;
  background: #FFFFFF;
}

.shop-chip[aria-current="page"] span {
  background: #0E4333;
  border-color: #0E4333;
  color: #FAF8F2;
}

@media (max-width: 767px) {
  .nav-wrapper:has(.shop-chip-nav),
  .nav-wrapper:has(.shop-chip-nav) > nav,
  .nav-wrapper:has(.shop-chip-nav) ul,
  .nav-wrapper:has(.shop-chip-nav) li {
    width: 100%;
    max-width: 100%;
  }
}
</style>
